import { useTranslation } from 'react-i18next'

import { DEFAULT_CURRENCY } from '@features/invoices/constants/defaultCurrency'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Currency } from '../../../../../../../types/currency'
import { useSalesReport } from '../../../../../contexts/salesReportContext'
import { SalesReportDateSelection } from '../../../../../enums/salesReportDateSelection'
import { useSalesReportFilters } from '../../../../../hooks/useSalesReportFilters'
import { useSalesReportVariant } from '../../../../../hooks/useSalesReportVariant'
import { SalesReportPdfStatistics } from '../types/salesReportPdfStatistics'
import { SalesReportPdfStatisticsItem } from '../types/salesReportPdfStatisticsItem'

export const useSalesReportPdfStatistics = (totalItems?: SalesReportPdfStatisticsItem): SalesReportPdfStatistics => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { totalPaidValue, totalUnpaidValue, totalSalesValue } = useSalesReport()
  const [{ dateSelection }] = useSalesReportFilters()
  const { salesReportVariant } = useSalesReportVariant()
  const currency = (organization?.baseCurrencyId ?? DEFAULT_CURRENCY) as Currency
  const shouldShowUnpaid = salesReportVariant !== 'overview' || dateSelection !== SalesReportDateSelection.Payment

  return {
    totalSales: {
      label: t('sales_report.statistics.summary.all_sales', { currency }),
      value: totalSalesValue || '0',
    },
    totalPaid: {
      label: t('sales_report.statistics.graph.invoices.paid'),
      value: totalPaidValue || '0',
    },
    totalUnpaid: shouldShowUnpaid
      ? {
          label: t('sales_report.statistics.graph.invoices.unpaid'),
          value: totalUnpaidValue || '0',
        }
      : undefined,
    totalItems: totalItems || undefined,
  }
}
